export default __webpack_public_path__ + "files/trend_stations-ad1e856415648731849b89d0a7e67700.pbf";